export const routes = [
  {
    path: '/app',
    /* internal name: 'app' */
    /* no component */
    children: [
      {
        path: 'admin',
        /* internal name: 'app-admin' */
        /* no component */
        children: [
          {
            path: '',
            name: 'app-admin',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/app/admin/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'client',
        /* internal name: 'app-client' */
        /* no component */
        children: [
          {
            path: '',
            name: 'app-client',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/app/client/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'client-product',
        /* internal name: 'app-client-product' */
        /* no component */
        children: [
          {
            path: '',
            name: 'app-client-product',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/app/client-product/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'image',
        /* internal name: 'app-image' */
        /* no component */
        children: [
          {
            path: '',
            name: 'app-image',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/app/image/index.vue'),
            /* no children */
          },
          {
            path: 'imageV1',
            name: 'app-image-image-v1',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/app/image/imageV1.vue'),
            /* no children */
          },
          {
            path: 'indexV1',
            name: 'app-image-index-v1',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/app/image/indexV1.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'image-position',
        /* internal name: 'app-image-position' */
        /* no component */
        children: [
          {
            path: '',
            name: 'app-image-position',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/app/image-position/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'location',
        /* internal name: 'app-location' */
        /* no component */
        children: [
          {
            path: '',
            name: 'app-location',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/app/location/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'playlist',
        /* internal name: 'app-playlist' */
        /* no component */
        children: [
          {
            path: '',
            name: 'app-playlist',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/app/playlist/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'profile',
        /* internal name: 'app-profile' */
        /* no component */
        children: [
          {
            path: '',
            name: 'app-profile',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/app/profile/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'role',
        /* internal name: 'app-role' */
        /* no component */
        children: [
          {
            path: '',
            name: 'app-role',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/app/role/index.vue'),
            /* no children */
          },
          {
            path: 'add',
            /* internal name: 'app-role-add' */
            /* no component */
            children: [
              {
                path: '',
                name: 'app-role-add',
                component: () => import('/var/www/fus/fus-cms-frontend/src/pages/app/role/add/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'update',
            /* internal name: 'app-role-update' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'app-role-update-id',
                component: () => import('/var/www/fus/fus-cms-frontend/src/pages/app/role/update/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'setting',
        /* internal name: 'app-setting' */
        /* no component */
        children: [
          {
            path: '',
            name: 'app-setting',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/app/setting/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'user',
        /* internal name: 'app-user' */
        /* no component */
        children: [
          {
            path: '',
            name: 'app-user',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/app/user/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'video',
        /* internal name: 'app-video' */
        /* no component */
        children: [
          {
            path: '',
            name: 'app-video',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/app/video/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/dashboards',
    /* internal name: 'dashboards' */
    /* no component */
    children: [
      {
        path: '',
        name: 'dashboards',
        component: () => import('/var/www/fus/fus-cms-frontend/src/pages/dashboards/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('/var/www/fus/fus-cms-frontend/src/pages/error.vue'),
    /* no children */
  },
  {
    path: '/fnetpro',
    /* internal name: 'fnetpro' */
    /* no component */
    children: [
      {
        path: 'dashboard',
        /* internal name: 'fnetpro-dashboard' */
        /* no component */
        children: [
          {
            path: '',
            name: 'fnetpro-dashboard',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/fnetpro/dashboard/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'detail-report',
        /* internal name: 'fnetpro-detail-report' */
        /* no component */
        children: [
          {
            path: '',
            name: 'fnetpro-detail-report',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/fnetpro/detail-report/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('/var/www/fus/fus-cms-frontend/src/pages/forgot-password.vue'),
    /* no children */
  },
  {
    path: '/game',
    /* internal name: 'game' */
    /* no component */
    children: [
      {
        path: 'fus',
        /* internal name: 'game-fus' */
        /* no component */
        children: [
          {
            path: '',
            name: 'game-fus',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/game/fus/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'h5',
        /* internal name: 'game-h5' */
        /* no component */
        children: [
          {
            path: '',
            name: 'game-h5',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/game/h5/index.vue'),
            /* no children */
          },
          {
            path: 'category',
            /* internal name: 'game-h5-category' */
            /* no component */
            children: [
              {
                path: '',
                name: 'game-h5-category',
                component: () => import('/var/www/fus/fus-cms-frontend/src/pages/game/h5/category/index.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'list',
        /* internal name: 'game-list' */
        /* no component */
        children: [
          {
            path: '',
            name: 'game-list',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/game/list/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('/var/www/fus/fus-cms-frontend/src/pages/login.vue'),
    /* no children */
  },
  {
    path: '/news',
    /* internal name: 'news' */
    /* no component */
    children: [
      {
        path: 'flash-news',
        /* internal name: 'news-flash-news' */
        /* no component */
        children: [
          {
            path: '',
            name: 'news-flash-news',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/news/flash-news/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'rss',
        /* internal name: 'news-rss' */
        /* no component */
        children: [
          {
            path: '',
            name: 'news-rss',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/news/rss/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/var/www/fus/fus-cms-frontend/src/pages/not-authorized.vue'),
    /* no children */
  },
  {
    path: '/report',
    /* internal name: 'report' */
    /* no component */
    children: [
      {
        path: 'ads-report',
        /* internal name: 'report-ads-report' */
        /* no component */
        children: [
          {
            path: '',
            name: 'report-ads-report',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/report/ads-report/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/stadium',
    /* internal name: 'stadium' */
    /* no component */
    children: [
      {
        path: 'feedback',
        /* internal name: 'stadium-feedback' */
        /* no component */
        children: [
          {
            path: '',
            name: 'stadium-feedback',
            component: () => import('/var/www/fus/fus-cms-frontend/src/pages/stadium/feedback/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  }
]
